// src/components/atoms/branded-qr-code.tsx
"use client"

import QRCode from "react-qr-code"

type Props = {
  value: string
  size?: number
}

export function BrandedQrCode({ value, size = 192 }: Props) {
  // A QR code encodes its value (usually a payment or deposit address) as SVG
  // paths, which session replay copies as-is and text masking cannot hide.
  // data-ph-no-capture makes replay block the whole code; the ph-no-capture
  // class keeps autocapture out too.
  return (
    <div
      data-ph-no-capture
      className="ph-no-capture relative inline-block rounded-lg border bg-white p-2"
      style={{ width: size + 16, height: size + 16 }}
    >
      <QRCode value={value} size={size} fgColor="#2C47E5" level="H" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="rounded bg-white p-1">
          <img
            src="/images/niftipay-icon-blue.svg"
            alt=""
            width={36}
            height={36}
          />
        </div>
      </div>
    </div>
  )
}
